import { ICourse } from '@interfaces/ICourse';
import { Action } from '@ngrx/store';

export enum ECoursesActions {
  GetCourses = '[Courses] Get Courses',
  GetCoursesSuccess = '[Courses] Get CoursesSuccess',
  ClearCoursesList = '[Courses] Clear Courses List',
}

export class GetCourses implements Action {
  public readonly type = ECoursesActions.GetCourses;
}

export class GetCoursesSuccess implements Action {
  public readonly type = ECoursesActions.GetCoursesSuccess;

  constructor(public courses: ICourse[]) {}
}

export class ClearCoursesList implements Action {
  public readonly type = ECoursesActions.ClearCoursesList;
}

export type CoursesActions = GetCourses | GetCoursesSuccess | ClearCoursesList;
